import { useParams } from 'react-router-dom';

export default function useReportId() {
    const { id } = useParams<{ id: string }>();
    return id;
}
